import { GAClientConfig } from '@domgen/dgx-components';

export const gaTagsConfig: GAClientConfig = {
  name: 'AO Claims',
};
